import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";

const DEFAULT_OFFER = "120410";
const AFF_ID = "123328";
const BASE = "https://click.beyondcheap.com/rdr3.php";
const CLICK_REF = "https://choose-my-hotel.com/";

function buildTarget(params) {
  const product_url = params.get("product_url") || "";
  const click_id = params.get("click_id") || "";
  const target = params.get("target") || "";
  const offer = params.get("offer") || DEFAULT_OFFER;

  // Each value is URL-encoded exactly once via URLSearchParams.
  const out = new URLSearchParams();
  out.set("aff_id", AFF_ID);
  out.set("cid", offer);
  out.set("url", product_url);
  out.set("click_id", click_id);
  out.set("ref_id", target);
  out.set("sub_id", target);
  out.set("click_ref", CLICK_REF);
  return `${BASE}?${out.toString()}`;
}

export default function GoPage() {
  const [error, setError] = useState("");

  useEffect(() => {
    try {
      // Widen referrer policy so the outbound Referer contains the full /go URL,
      // not just the origin — matches the fast-path in public/index.html.
      var m = document.querySelector('meta[name="referrer"]');
      if (m) m.setAttribute("content", "no-referrer-when-downgrade");

      const params = new URLSearchParams(window.location.search);
      const product_url = params.get("product_url");
      if (!product_url) {
        setError("Missing product_url");
        return;
      }
      const dest = buildTarget(params);
      // Client-side replace — keeps the document Referer = choose-my-hotel.com/go...
      // Server-side 301/302 would NOT preserve our domain as Referer.
      window.location.replace(dest);
    } catch (e) {
      setError("Redirect failed");
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Redirecting…</title>
        <meta name="robots" content="noindex,nofollow,noarchive,nosnippet" />
        <meta name="referrer" content="no-referrer-when-downgrade" />
      </Helmet>
      <main
        data-testid="go-redirect-page"
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "system-ui, -apple-system, sans-serif",
          color: "#1A1A1A",
          background: "#F9F6F0",
          fontSize: "14px",
          letterSpacing: "0.04em",
        }}
      >
        {error ? (
          <span data-testid="go-redirect-error" style={{ color: "#C86B53" }}>{error}.</span>
        ) : (
          <span data-testid="go-redirect-message">Redirecting…</span>
        )}
      </main>
    </>
  );
}
